import { HowItWorksSection } from "@/components/landing/HowItWorksSection";

export default function HowDuriWorks() {
  return (
    <div className="min-h-screen bg-background">
      <HowItWorksSection />
    </div>
  );
}
